/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./drawerLinksEdit.vue?vue&type=template&id=5852efe9&scoped=true&"
import script from "./drawerLinksEdit.vue?vue&type=script&lang=js&"
export * from "./drawerLinksEdit.vue?vue&type=script&lang=js&"
import style0 from "./drawerLinksEdit.vue?vue&type=style&index=0&id=5852efe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5852efe9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
